"use client";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useUpdateEmailDraftMutation } from "../../../services/draftsService";
import { EmailTemplateForm } from "./EmailTemplateForm";

export function EmailTemplateEditDialog(props) {
    const { t } = useTranslation();
    const { mutate: updateEmailDraft } = useUpdateEmailDraftMutation({
        onSuccess: () => {
            props.onSuccessUpdate();
            props.onClose();
        },
    });

    const handleSubmit = (data) => {
        if (!props.template) {
            return;
        }
        console.log("Submitting form data:", data);
        updateEmailDraft({
            draftId: props.template.id,
            data: {
                nr: data.templateNumber,
                name: data.templateName,
                description: data.templateDescription,
                subject: data.subject,
                body: data.body,
                language: data.templateLanguage,
                active: data.active === "true",
                draft_notification: data.draftNotification
            },
        });
    };

    const handleError = (errors) => {
        console.error("Form validation errors:", errors);
    };

    if (!props.template) {
        return null;
    }

    const defaultValues = {
        templateNumber: props.template.template_number,
        templateLanguage: props.template.language,
        templateName: props.template.template_name,
        templateDescription: props.template.description,
        subject: props.template.subject,
        body: props.template.body,
        active: props.template.active.toString(),
        draftNotification: props.template.draft_notification_id
    };

    return (
        <Dialog open={props.open} onClose={props.onClose} maxWidth="md" fullWidth>
            <DialogTitle
                sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
                {props.title}
                <IconButton onClick={props.onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ pt: 2 }}>
                <EmailTemplateForm
                    defaultValues={defaultValues}
                    onSubmit={handleSubmit}
                    onError={handleError}
                    submitBtnText={t("drafts.saveTemplate")}
                    draftType={props.draftType}
                />
            </DialogContent>
        </Dialog>
    );
}
